import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useState, useEffect } from 'react';
import Util from "../../Service/util";
import Service from "../../Service/http";
import { FadeLoader } from "react-spinners";
import { toast } from "react-toastify";
import Spinner from 'react-bootstrap/Spinner';

function AddProblem() {
    let [SiteOptions, SetSitesOptions] = useState([]);
    const service = new Service();
    const util = new Util();
    let [loggedIn, SetLoggedIn] = useState(false);
    let [isAdmin, SetIsAdmin] = useState(false);
    let [role, SetRole] = useState("student");
    let [GproblemId, setGProblemId] = useState("");
    let [loading, setLoading] = useState(false);
    let [problem, setProblem] = useState({
        problemId: "",
        siteName: "",
        problemName: ""
    });

    function debounce(func, timeout = 1000) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }
    const processChange = debounce((text) => {
        getProblemTitleFromId(text);
    });

    const getProblemTitleFromId = async (problemId) => {
        try {
            if (problemId.length === 0) {
                setProblem({ ...problem, problemName: "" });
                return;
            }
            setLoading(true);

            if (problem.siteName === "CODEFORCES") {
                if (!problemId.includes("/")) {
                    setProblem({ ...problem, problemName: "" });
                    setLoading(false);
                    return;
                }
                let serializeId = problemId.split("/");
                problemId = serializeId[0] + "-" + serializeId[1];
            }

            const response = await service.get(`api/getproblemname/${problemId}/${problem.siteName}`);
            if (response.problemName === null) {
                setProblem({ ...problem, problemName: "", isProblemNotFound: true });
            } else {
                setProblem({ ...problem, problemName: response.problemName, isProblemNotFound: false });
            }
    
        } catch (error) {
            console.error("Error fetching problem title:", error);
            setProblem({ ...problem, problemName: "", isProblemNotFound: true });
        } finally {
            setLoading(false);
        }
    };

    const handleAddProblem = () => {
        problem.problemId = GproblemId;
        if (problem.siteName.length === 0) {
            toast.error("Site is Mandatory");
            return;
        }
        if (problem.problemId.length === 0) {
            toast.error("Problem ID is Mandatory");
            return;
        }
        if (problem.problemName.length === 0) {
            toast.error("Problem Name is Mandatory");
            return;
        }
        setLoading(true);
        service.post("api/problems/add", { problem })
            .then(() => {
                setProblem({
                    problemId: "",
                    siteName: "",
                    problemName: ""
                });
                setLoading(false);
                toast.success("Added New Problem To DB");
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error While Adding Problem To DB");
                console.error(error);
            });
    };

    useEffect(() => {
        const isLogin = util.loggedIn();
        const admin = util.isAdmin();
        SetRole(util.getRole());
        SetIsAdmin(admin);
        SetLoggedIn(isLogin);
        if (!isLogin && window.location.pathname !== "/login") {
            window.location.replace("/login");
        }
        if (isLogin && admin) {
            service.get("api/sites/options")
                .then((json) => {
                    SetSitesOptions(json.filter((option) => option !== "dont_show_criteria"));
                })
                .catch((error) => {
                    console.error("Error fetching site options:", error);
                });
        }
    }, []);
    const isError = problem.isProblemNotFound;
    return (
<div className='card' style={{ maxWidth: '100%', margin: 'auto', padding: '1%' , height : '500px' , width : '900px'}}>
    <h3 className='text-center card-title text-primary' style={{ margin: "3%" , marginBottom : "6%" }}>ADD NEW PROBLEM</h3>
    <div>
        <div className="container card-body" style={{ padding: '0' }}>
            <div className="row" style={{ gap: '2px' }}>
                <div className="col" style={{ flex: '1', minWidth: '250px', maxWidth: '400px', marginLeft : "2%" }}>
                    <Autocomplete
                        getOptionDisabled={(option) =>
                            option === SiteOptions[2] || option === SiteOptions[3] || option === SiteOptions[4] || option === SiteOptions[5] || option === SiteOptions[6] || option === SiteOptions[7]
                        }
                        disablePortal
                        id="combo-box-demo"
                        options={SiteOptions}
                        onChange={(e, option) => {
                            setProblem({
                                ...problem,
                                siteName: option ? option : ''
                            });
                        }}
                        required={true}
                        style={{ width: "100%", margin: "1%" }} // Full width with margin
                        renderInput={(params) => <TextField {...params} label="Select Site" />}
                    />
                </div>
                <div className="col" style={{ flex: '1', minWidth: '200px', maxWidth: '350px' }}>
                    <TextField
                        disabled={problem.siteName.length === 0}
                        id="outlined-basic"
                        label="Problem ID"
                        variant="outlined"
                        style={{ width: "100%", margin: "1%" }} // Full width with margin
                        required={true}
                        onChange={(e) => {
                            setGProblemId(e.target.value);
                            processChange(e.target.value);
                        }}
                    />
                </div>
                <div className="col" style={{ flex: '2', minWidth: '200px', maxWidth: '300px', position: 'relative', marginRight : "2%" }}>
                <TextField
                    error={isError}
                    id="outlined-basic"
                    disabled={true}
                    label="Problem Name"
                    variant="outlined"
                    value={problem.problemName}
                    style={{
                        width: "100%",
                        margin: "1%",
                        backgroundColor: problem.problemName && !isError ? 'lightgreen' : undefined, 
                    }}
                    required={true}
                    InputLabelProps={{
                        style: {
                            color: problem.problemName && !isError ? 'green' : undefined, // Green label if there's text and no error
                            fontWeight: problem.problemName && !isError ? 'bold' : undefined // Heavier font weight if there's text and no error
                        }
                    }}
                    InputProps={{
                        style: {
                            color: problem.problemName && !isError ? 'black' : undefined ,
                            opacity : 1// Black text if there's text and no error
                        }
                    }}
                />




                    {loading&& (
                        <div style={{ 
                            position: 'absolute', 
                            top: '50%', 
                            left: '50%', 
                            transform: 'translate(-50%, -50%)', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            width: '24px',  // Adjusted size
                            height: '24px', 
                            backgroundColor: 'rgba(255, 255, 255, 0)', 
                            zIndex: 1 
                        }}>
                            <Spinner 
                                animation="border" 
                                variant="primary" 
                                style={{ width: '24px', height: '24px' }} // Adjust size
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className="text-center">
                <Button
                    onClick={handleAddProblem}
                    variant="contained"
                    style={{ width: "100%", maxWidth: "200px", margin: "20px auto", marginTop: "50px" }} // Responsive button width
                    endIcon={<AddCircleOutlineIcon style={{ height: "20px" }} />}
                >
                    Add Problem
                </Button>
            </div>
        </div>
    </div>
</div>

    );
}

export default AddProblem;
